import { io } from 'socket.io-client';
import { normalizeRealtimeUsername, showRealtimeSubscriptionEmits, } from './realtime-subscription.js';
function resolveSocketTarget(apiBaseUrl) {
    const trimmed = apiBaseUrl.replace(/\/$/, '') || '/api';
    if (/^https?:\/\//i.test(trimmed)) {
        return { url: trimmed, path: '/socket.io' };
    }
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    return {
        url: origin,
        path: `${trimmed}/socket.io`,
    };
}
/**
 * Creates a Socket.IO client for show/cams live push.
 * Shares one connection; call `subscribe` when routes change.
 * Pass `getAccessToken` so `subscribe:model` (request board) can authenticate.
 * Watchers also join `subscribe:presence` so go-live reaches an offline storefront.
 */
export function createShowRealtimeClient(config, handlers = {}) {
    const { url, path } = resolveSocketTarget(config.apiBaseUrl);
    const socket = io(url, {
        path,
        transports: ['websocket', 'polling'],
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 1_000,
        reconnectionDelayMax: 8_000,
        withCredentials: true,
        auth: (cb) => {
            const token = config.getAccessToken?.() ?? null;
            cb(token ? { token } : {});
        },
    });
    let current = {};
    socket.on('show.updated', (event) => {
        handlers.onShowUpdated?.(event);
    });
    socket.on('show.ended', (event) => {
        handlers.onShowEnded?.(event);
    });
    socket.on('cams.changed', (event) => {
        handlers.onCamsChanged?.(event);
    });
    socket.on('show.requests.changed', (event) => {
        handlers.onShowRequestsChanged?.(event);
    });
    socket.on('stream.signal', (event) => {
        handlers.onStreamSignal?.(event);
    });
    socket.on('show.caption', (event) => {
        handlers.onShowCaption?.(event);
    });
    const applySubscription = (next) => {
        for (const [event, payload] of showRealtimeSubscriptionEmits(current, next)) {
            if (payload === undefined) {
                socket.emit(event);
            }
            else {
                socket.emit(event, payload);
            }
        }
        current = {
            username: normalizeRealtimeUsername(next.username),
            showId: next.showId ?? null,
            cams: Boolean(next.cams),
        };
    };
    socket.on('connect', () => {
        const snapshot = { ...current };
        current = {};
        applySubscription(snapshot);
    });
    return {
        socket,
        subscribe: applySubscription,
        sendStreamSignal: (payload) => {
            socket.emit('stream.signal', payload);
        },
        sendShowCaption: (payload) => {
            socket.emit('show.caption', payload);
        },
        disconnect: () => {
            socket.removeAllListeners();
            socket.disconnect();
        },
    };
}
//# sourceMappingURL=realtime.js.map